/**
 * Set max height for dropdown filters
 */
	const siteGroupsHeight = () => {
		const siteGroups = document.querySelectorAll('.group')

		if (siteGroups.length > 0) {
			siteGroups.forEach(e => {
				e.style.setProperty('--group-height', e.offsetHeight + 'px')
			})
		}
	}

	window.addEventListener('load', _ => {
		siteGroupsHeight()
	})

	window.addEventListener('resize', _ => {
		setTimeout(() => {
			siteGroupsHeight()
		}, 100);
	})
